import { mutationTypes } from './types'
import { Modes } from '@/utils/enums'
import initialState from './initial-state'

export default {
  [mutationTypes.RESET_STATE]: (state, dirty) => {
    const initState = initialState()
    Object.keys(initState).forEach(key => {
      state[key] = initState[key]
    })
  },
  [mutationTypes.SET_TITLE]: (state, title) => {
    state.title = title
  },
  [mutationTypes.SET_SELECTED_RANGE]: (state, selectedRange) => {
    state.selectedRange = selectedRange
  },
  [mutationTypes.SET_SUBTITLE]: (state, subtitle) => {
    state.subtitle = subtitle
  },
  [mutationTypes.SET_SHOWING_UNSAVED_DIALOG]: (state, showingUnsavedDialog) => {
    state.showingUnsavedDialog = showingUnsavedDialog
  },
  [mutationTypes.SET_DIRTY]: (state, dirty) => {
    state.dirty = dirty
  },
  [mutationTypes.SAVING_PENDING]: (state) => {
    state.saving = true
  },
  [mutationTypes.SAVING_SUCCESS]: (state) => {
    state.saving = false
    state.dirty = false
  },
  [mutationTypes.SAVING_FAILURE]: (state, error) => {
    state.saving = false
  },
  [mutationTypes.ADD_ERROR]: (state, err) => {
    state.errors.push(err)
  },
  [mutationTypes.REMOVE_ERROR]: (state, err) => {
    state.errors = state.errors.filter(error => error !== err)
  },
  [mutationTypes.REFRESH_METADATA_SUCCESS]: (state, data) => {
    state.refreshingMetadata = false
    state.total = data.total
    state.dirty = data.dirty
  },
  [mutationTypes.REFRESH_METADATA_PENDING]: (state) => {
    state.refreshingMetadata = true
  },
  [mutationTypes.REFRESH_METADATA_FAILURE]: (state, data) => {
    state.refreshingMetadata = false
    state.errors.push(data.error)
    state.mode = data.mode
  },
  [mutationTypes.REFRESH_SUCCESS]: (state, data) => {
    state.refreshing = false
    state.total = data.total
    state.columns = data.columns
    state.dirty = data.dirty
  },
  [mutationTypes.REFRESH_PENDING]: (state) => {
    state.refreshing = true
  },
  [mutationTypes.REFRESH_FAILURE]: (state, data) => {
    state.refreshing = false
    state.errors.push(data.error)
    state.mode = data.mode
  },
  [mutationTypes.CLEAR_CELL_PENDING]: (state) => {
    state.clearing = true
  },
  [mutationTypes.CLEAR_CELL_SUCCESS]: (state) => {
    state.clearing = false
    state.dirty = true
  },
  [mutationTypes.CLEAR_CELL_FAILURE]: (state, error) => {
    state.clearing = false
  },
  [mutationTypes.CLEAR_CELLS_PENDING]: (state) => {
    state.clearing = true
  },
  [mutationTypes.CLEAR_CELLS_SUCCESS]: (state) => {
    state.clearing = false
    state.dirty = true
  },
  [mutationTypes.CLEAR_CELLS_FAILURE]: (state, error) => {
    state.clearing = false
  },
  [mutationTypes.INSERTING_PENDING]: (state) => {
    state.inserting = true
  },
  [mutationTypes.INSERTING_SUCCESS]: (state) => {
    state.inserting = false
    state.total++ // we need to update total, so that splice in refresh data works correctly
  },
  [mutationTypes.INSERTING_FAILURE]: (state, error) => {
    state.inserting = false
  },
  [mutationTypes.EDIT_CELL_SUCCESS]: (state, data) => {
    state.dirty = true
    state.currentlyEditingCells = state.currentlyEditingCells.filter(cell => cell.row !== data.row && cell.col !== data.col)
  },
  [mutationTypes.EDIT_CELL_FAILURE]: (state, data) => {
    state.currentlyEditingCells = state.currentlyEditingCells.filter(cell => cell.row !== data.row && cell.col !== data.col)
    state.errors.push(data.error)
  },
  [mutationTypes.EDIT_CELL_PENDING]: (state, cell) => {
    state.currentlyEditingCells.push(cell)
  },
  [mutationTypes.LOAD_REPORT_SUCCESS]: (state, data) => {
    state.total = data.total
    state.title = data.title
    state.subtitle = data.subTitle
    state.dirty = data.dirty
    state.columnHeaderMetaData = data.columnHeaderMetaData
    state.canInsert = data.canInsert
    state.columns = data.columns
  },
  [mutationTypes.LOAD_REPORT_FAILURE]: (state, err) => {
    state.mode = Modes.ReadOnly
    state.loading = false
  },
  [mutationTypes.LOAD_REPORT_PENDING]: (state) => {
    state.loading = true
  },
  [mutationTypes.LOADING_FINISHED]: (state) => {
    state.loading = false
  },
  [mutationTypes.SWITCH_TO_READ_ONLY_MODE_PENDING]: (state) => {
    state.switchingToReadOnlyMode = true
  },
  [mutationTypes.SWITCH_TO_READ_ONLY_MODE_SUCCESS]: (state) => {
    state.switchingToReadOnlyMode = false
    state.mode = Modes.ReadOnly
  },
  [mutationTypes.SWITCH_TO_READ_ONLY_MODE_FAILURE]: (state, error) => {
    state.switchingToReadOnlyMode = false
  },
  [mutationTypes.SET_READ_ONLY_MODE]: (state) => {
    state.mode = Modes.ReadOnly
  }
}
